import { ProcedureType, VisitType } from "./health.wallet.dtos";
export const VISIT_TYPE_FILTER_ID = {
    [VisitType.PRIMARY_CARE]: "primary-care",
    [VisitType.SPECIALIST]: "specialist",
    [VisitType.URGENT_CARE]: "urgent-care",
    [VisitType.EMERGENCY]: "emergency",
    [VisitType.ANNUAL_PHYSICAL]: "annual-physical",
    [VisitType.MENTAL_HEALTH]: "mental-health",
    [VisitType.PSYCHIATRY]: "mental-health",
    [VisitType.DENTAL]: "dental",
    [VisitType.VISION]: "vision",
    [VisitType.PHYSICAL_THERAPY]: "rehabilitation",
    [VisitType.ALTERNATIVE_CARE]: "wellness",
    [VisitType.OBSTETRICS]: "ob-gyn",
};
export const PROCEDURE_TYPE_FILTER_ID = {
    [ProcedureType.PROCEDURE]: "procedure",
    [ProcedureType.LAB_DRAW]: "lab-draw",
    [ProcedureType.IMAGING]: "imaging",
    [ProcedureType.CARDIOLOGY]: "cardiology",
    [ProcedureType.PATHOLOGY]: "pathology",
    [ProcedureType.OTHER_DIAGNOSTIC]: "other-diagnostic",
};
export var SourceVisitBucket;
(function (SourceVisitBucket) {
    SourceVisitBucket["ROUTINE"] = "ROUTINE";
    SourceVisitBucket["SPECIALIST"] = "SPECIALIST";
    SourceVisitBucket["UNPLANNED"] = "UNPLANNED";
})(SourceVisitBucket || (SourceVisitBucket = {}));
const ROUTINE_FILTER_IDS = [
    "primary-care",
    "annual-physical",
    "ob-gyn",
    "mental-health",
    "dental",
    "vision",
    "rehabilitation",
    "wellness",
];
const SPECIALIST_FILTER_IDS = ["specialist"];
const UNPLANNED_FILTER_IDS = ["urgent-care", "emergency"];
export function bucketForVisitType(visitType) {
    const filterId = VISIT_TYPE_FILTER_ID[visitType];
    if (!filterId)
        return null;
    if (ROUTINE_FILTER_IDS.includes(filterId))
        return SourceVisitBucket.ROUTINE;
    if (SPECIALIST_FILTER_IDS.includes(filterId))
        return SourceVisitBucket.SPECIALIST;
    if (UNPLANNED_FILTER_IDS.includes(filterId))
        return SourceVisitBucket.UNPLANNED;
    return null;
}
export function visitTypesForBucket(bucket) {
    return Object.values(VisitType).filter((visitType) => bucketForVisitType(visitType) === bucket);
}
